<template>
    <div class="removeDialog">
        <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
            <div class="select">
                <div class="title">
                    <i @click="existence" class="el-icon-caret-bottom" style="cursor: pointer;"></i>
                    快速分类选择（亚洲已排除中国大陆）
                </div>
                <div v-if="bodyFlag">
                    <el-tree ref="multipleTable" :data="data" :render-content="renderContent" show-checkbox
                        node-key="id" @node-expand="handleExpand" :props="defaultProps"
                        @check-change="handleCheckChange">
                    </el-tree>
                </div>
            </div>
            <div v-if="title=='批量排除国家/地区'" id="tag1" @paste="paste" class="display" contenteditable="true" placeholder="批量输入国家/地区名称，每行一个；可通过上方的分类快速选择">
            </div>
            <div id="tag2" v-if="title=='批量定位国家/地区'" @paste="paste" class="display" contenteditable="true" placeholder="批量输入国家/地区名称，每行一个；可通过上方的分类快速选择">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="exit">开始匹配</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="Visible" width="40%">
            <div class="body">
                <el-tabs v-model="activeName">
                    <el-tab-pane v-for="item in boxContent" :key="item.name" :label="item.label" :name="item.name">
                        <div class="body-box">
                            <div class="body-title">
                                <span class="main">{{item.main}}</span>
                                <span class="sub" @click="copyToClip(item)">复制</span>
                            </div>
                            <div v-if="title=='批量排除国家/地区'" :id="item.name" class="body-content" v-html="item.content"></div>
                            <div v-if="title=='批量定位国家/地区'" :id="item.name" class="body-content" v-html="item.content"></div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="Toreturn">返回</el-button>
                <el-button v-if="this.title=='批量排除国家/地区'" type="primary" @click="confirmRemove">确认排除符合条件的国家/地区</el-button>
                <el-button v-if="this.title=='批量定位国家/地区'" type="primary" @click="confirmlocation">确认定位符合条件的国家/地区</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js'
export default {
    props: ['dialogVisible', 'title'],
    data() {
        return {
            boxContent: [
                {
                    label: '',
                    name: this.title=='批量排除国家/地区' ? 'first' : 'one',
                    main: this.title=='批量排除国家/地区' ? '以下是符合条件的国家/地区，可以排除' : '以下是符合条件的国家/地区，可以定位',
                    content: '',
                },
                {
                    label: '',
                    name: this.title=='批量排除国家/地区' ? 'second' : 'two',
                    main: '未匹配到以下国家/地区，可能是拼写错误，请检查',
                    content: '',
                },
                {
                    label: '',
                    name: this.title=='批量排除国家/地区' ? 'third' : 'three',
                    main: this.title=='批量排除国家/地区' ? '以下国家/地区已经在排除列表，不能重复排除' : '以下国家/地区已经在排除列表，不能既排除又定位',
                    content: '',
                },
                {
                    label: '',
                    name: this.title=='批量排除国家/地区' ? 'fourth' : 'four',
                    main: this.title=='批量排除国家/地区' ? '以下国家/地区已经在定位列表，不能既定位又排除' : '以下国家/地区已经在定位列表，不能重复定位',
                    content: '',
                }
            ],
            activeName: this.title=='批量排除国家/地区' ? 'first' : 'one',
            Visible: false,
            bodyFlag: false,
            data: [],
            defaultProps: {
                children: 'geotargetsGroupSonVOList',
                label: 'name'
            },
            nameList: [],
            country: '',
            excludeList: [],//已排除地区
            locationList: [],//已定位地区
            matchingList: [], //符合条件地区
            noMatchingList: [], //未匹配成功地区
        };
    },
    methods: {
        async getgroupList() {
            let res = await adsNewOnlineSer.getgroupList();
            this.data = res.data
            this.data.map(function (item) {
                item.name = `${item.name}(${item.quantity})`;
                if (item.geotargetsGroupSonVOList) {
                    item.geotargetsGroupSonVOList.map(function (ele) {
                        ele.name = `${ele.name}(${ele.quantity})`;
                    });
                }
            });
        },
        async geotargetsmatching() {
            let res = await adsNewOnlineSer.geotargetsmatching({
                automationId: this.automationId,
                nameList: this.nameList
            })
            this.matchingList = res.data.matchingList;
            this.boxContent[0].label = `符合条件(${this.matchingList.length})`
            this.noMatchingList = res.data.noMatchingList;
            this.boxContent[1].label = `未匹配到(${this.noMatchingList.length})`
            this.excludeList = res.data.excludeList;
            this.boxContent[2].label = `已排除(${this.excludeList.length})`
            this.locationList = res.data.locationList;
            this.boxContent[3].label = `已定位(${this.locationList.length})`
        },
        paste(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var text = '',
                            event = e.originalEvent || e;
                    if (event.clipboardData && event.clipboardData.getData) {
                            text = event.clipboardData.getData('text/plain');
                    } else if (window.clipboardData && window.clipboardData.getData) {
                            text = window.clipboardData.getData('Text');
                    }
                    if (document.queryCommandSupported('insertText')) {
                            document.execCommand('insertText', false, text);
                    } else {
                            document.execCommand('paste', false, text);
                    }
        },
        selectText(element){
            var text = document.getElementById(element);
            if (document.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
            } else if (window.getSelection) {
            var selection = window.getSelection();
            let range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
            }
        },
        copyToClip (item) {
            var input = document.createElement("input"); // 创建input对象
            input.value = item.content; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            // input.select(); // 选择实例内容
            this.selectText(item.name);
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message.success('复制成功！');
        },
        Toreturn(){
            this.Visible = false;
            if(this.title == '批量排除国家/地区'){
                this.$emit('changeDia',true);
            }else if(this.title == '批量定位国家/地区'){
                this.$emit('changelaDia',true);
            }
        },
        confirmRemove(){
            this.$emit('confirmR',this.matchingList);
            this.Visible = false;
            var tag = document.getElementById('tag1');
            tag.innerHTML = '';
        },
        confirmlocation(){
            this.$emit('confirmL',this.matchingList);
            this.Visible = false;
            var tag = document.getElementById('tag2');
            tag.innerHTML = '';
        },
        handleCheckChange() {
            let a = this.$refs.multipleTable.getCheckedNodes();
            a.map(function (item, index) {
                if (item.geotargetsGroupSonVOList) {
                    return a.splice(index, 1)
                } else {
                    return a;
                }
            });
            let arrold = a.map((obj) => {
                return obj.geotargetsVOList;
            })
            let arrnew = [].concat(...arrold).map((obj) => {
                return obj.name;
            });
            this.country = arrnew.join('<br>');
            if(this.title=='批量排除国家/地区'){
                let tag = document.getElementById('tag1');
                tag.innerHTML = this.country;
            }else{
                let tag = document.getElementById('tag2');
                tag.innerHTML = this.country;
            }
        },
        handleExpand() {//节点被展开时触发的事件
            //因为该函数执行在renderContent函数之前，所以得加定时
            setTimeout(() => {
                this.changeCss();
            }, 10);
        },
        renderContent(h, { node }) {//树节点的内容区的渲染 Function
            let classname = "";
            // 由于项目中有三级菜单也有四级级菜单，就要在此做出判断
            if (node.level === 2) {
                classname = "foo";
            }
            // if (node.level === 3 && node.childNodes.length === 0) {
            //     classname = "foo";
            // }
            return h(
                "p",
                {
                    class: classname
                },
                node.label
            );
        },
        changeCss() {
            var levelName = document.getElementsByClassName("foo"); // levelname是上面的最底层节点的名字
            for (var i = 0; i < levelName.length; i++) {
                // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
                levelName[i].parentNode.style.cssFloat = "left"; // 最底层的节点，包括多选框和名字都让他左浮动
                levelName[i].parentNode.style.styleFloat = "left";
                levelName[i].parentNode.onmouseover = function () {
                    this.style.backgroundColor = "#fff";
                };
            }
        },
        handleClose() {
            if(this.title == '批量排除国家/地区'){
                this.$emit('changeDia',false);
            }else if(this.title == '批量定位国家/地区'){
                this.$emit('changelaDia',false);
            }
        },
        existence() {
            this.bodyFlag = !this.bodyFlag
        },
        exit() {
            let text = '';
            if(this.title == '批量排除国家/地区'){
                text = document.getElementById('tag1').innerHTML;
            }else if(this.title == '批量定位国家/地区'){
                text = document.getElementById('tag2').innerHTML;
            }
            this.nameList = [];
            if(text){
                    let str = text.replace(/<br>/g, ',').replace(/<\/div><div>/g, ',').replace(/<div>/g, ',').replace(/<\/div>/g, ',');
                    let arr = str.split(',');
                    let newArr = arr.map((item)=>{
                        return item.replace(/\r/g, '');
                    });
                    newArr.forEach(item => {
                        if (item) {
                            this.nameList.push(item)
                        }
                    });
                }else{
                    this.nameList = [];
                }
                this.geotargetsmatching().then(async () => {
                this.boxContent[0].content = this.matchingList.map((obj) => {
                    return obj.name;
                }).join('<br>');
                this.boxContent[1].content =  this.noMatchingList.map((obj) => {
                    return obj.name;
                }).join('<br>');
                this.boxContent[2].content =  this.excludeList.map((obj) => {
                    return obj.name;
                }).join('<br>');
                this.boxContent[3].content = this.locationList.map((obj) => {
                    return obj.name;
                }).join('<br>');
                if(this.title == '批量排除国家/地区'){
                    // var tag = document.getElementById('tag1');
                    // tag.innerHTML = '';
                    this.$emit('changeDia',false);
                }else if(this.title == '批量定位国家/地区'){
                    // var tag = document.getElementById('tag2');
                    // tag.innerHTML = '';
                    this.$emit('changelaDia',false);
                }
                this.Visible = true;
            });
        }
    },
    computed: {
        automationId() {
            return this.$route.query.id;
        }
    },
    mounted() {
        this.getgroupList();
    }
};
</script>
<style lang="scss" scoped>
.removeDialog {
    .select {
        border: 1px solid #DADADA;
        margin-bottom: 15px;

        .title {
            height: 54px;
            background: #FAFAFA;
            border-bottom: 1px solid #DADADA;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 54px;
        }
    }
    @mixin scrollbar(){
		// 改变滚动条样式
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #e8e8e8;
			border-radius: 6px;
		}

		&::-webkit-scrollbar-track {
			background-color: #fff;
			border-radius: 2px;
		}
	}
    .display {
        overflow-y: auto;
        padding: 5px;
        height: 150px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        @include scrollbar;
        &:empty:before {
            content: attr(placeholder);
            color: #999999 ;
        }
    /* 输入框获取焦点时移除 placeholder */
        &:focus:before {
            content: none;
            }
    }

    .body {
        height: 300px;
        border: 1px solid #DADADA;

        ::v-deep .el-tabs__nav-wrap {
            background-color: #FAFAFA;
        }

        ::v-deep .el-tabs__nav {
            margin-left: 100px;
        }

        .body-box {
            width: 90%;
            height: 220px;
            margin: 10px auto;
            background-color: #F9F9F9;
            border-radius: 4px;
            border: 1px solid #DADADA;

            .body-title {
                height: 22px;
                margin: 10px;

                .main {
                    font-size: 16px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 22px;
                }

                .sub {
                    float: right;
                    font-size: 14px;
                    font-weight: 400;
                    color: #3DA1FF;
                    line-height: 22px;
                    cursor: pointer;
                }
            }

            .body-content {
                height: 170px;
                overflow-y: auto;
                margin: 10px;
                @include scrollbar;
            }
        }
    }
}
</style>